import React from 'react'
import { Box, Chip, Stack, Typography } from '@mui/material'
import { ReportFilters } from '../../shared/filters/types'

export interface AudiencePreset {
  key: string
  label: string
  market: string
  visibleToRole: string
}

export const AUDIENCE_PRESETS: AudiencePreset[] = [
  { key: 'anz_fp', label: 'ANZ FP', market: 'ANZ', visibleToRole: 'FP_USER' },
  { key: 'usa_fp', label: 'USA FP', market: 'USA', visibleToRole: 'FP_USER' },
  { key: 'anz_psc', label: 'ANZ PSC', market: 'ANZ', visibleToRole: 'PSC_TEAM' },
  { key: 'usa_psc', label: 'USA PSC', market: 'USA', visibleToRole: 'PSC_TEAM' },
  { key: 'evo_team', label: 'Evo Team', market: '', visibleToRole: 'EVO_TEAM' },
  { key: 'admin_only', label: 'Admin only', market: '', visibleToRole: 'EVO_ADMIN' },
]

interface AudiencePresetChipsProps {
  filters: ReportFilters
  onApplyPreset: (market: string, visibleToRole: string) => void
}

const isPresetActive = (preset: AudiencePreset, filters: ReportFilters): boolean => {
  const currentMarket = filters.market || ''
  const currentRole = filters.visibleToRole || ''
  return currentMarket === preset.market && currentRole === preset.visibleToRole
}

const labelStyle = {
  fontWeight: 600,
  color: 'text.secondary',
  fontSize: '0.75rem',
  mb: 0.5,
  display: 'block',
}

const AudiencePresetChips: React.FC<AudiencePresetChipsProps> = ({ filters, onApplyPreset }) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography component="label" sx={labelStyle}>
        Audience
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {AUDIENCE_PRESETS.map((preset) => {
          const active = isPresetActive(preset, filters)
          return (
            <Chip
              key={preset.key}
              label={preset.label}
              size="small"
              clickable
              color={active ? 'primary' : 'default'}
              variant={active ? 'filled' : 'outlined'}
              onClick={() => {
                if (active) {
                  onApplyPreset('', '')
                } else {
                  onApplyPreset(preset.market, preset.visibleToRole)
                }
              }}
            />
          )
        })}
      </Stack>
    </Box>
  )
}

export default AudiencePresetChips
